"use strict";

exports.__esModule = true;
exports["default"] = void 0;

// https://www.javascripttutorial.net/dom/css/check-if-an-element-is-visible-in-the-viewport/
// To check if an element is visible in the viewport
var isInViewport = function isInViewport(element) {
  var rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};

var _default = isInViewport;
exports["default"] = _default;